import styled from 'styled-components';

export const FooterContainer = styled.div`
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
`;

export const TextLine = styled.p`
    color: ${ ({ theme: { textColor } }) => textColor };
    font-size: 12px;
    text-align: center;
`;
